import React from "react";

export interface FaqItem {
  question: string;
  answer: string;
}

export interface FaqListProps {
  items: FaqItem[];
  className?: string;
}

export const FaqList = ({ items, className }: FaqListProps) => {
  if (!items?.length) {
    return null;
  }
  return (
    <section
      className={"mt-12 " + (className ?? "")}
      aria-labelledby="faq-heading"
    >
      <h2
        id="faq-heading"
        className="text-text-primary mb-6 font-heading text-2xl font-bold"
      >
        Frequently Asked Questions
      </h2>
      <dl className="space-y-6">
        {items.map((faq, i) => (
          <div
            key={i}
            className="rounded-lg border border-gray-200 bg-gray-50 p-4"
          >
            <dt className="mb-2 text-lg font-semibold text-brand-700">
              {faq.question}
            </dt>
            <dd className="text-gray-700">{faq.answer}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
};
